(function() {
  'use strict';

  angular.module('eclipseApp.onboarding').factory('onboardingService', onboardingService);

  onboardingService.$inject = [
    '$http',
    '$q',
    '$window',
    '$state',
    'uteLocale',
    'ute.sms.recovery.fido.service',
    'onlineBillingService',
    'ute.datalayer.common.service',
    'uteEndpoint',
    'commonService'
  ];

  /* @ngInject */
  function onboardingService(
    $http,
    $q,
    $window,
    $state,
    uteLocale,
    recoveryService,
    onlineBillingService,
    dataLayerService,
    uteEndpoint,
    commonService
  ) {
    var isRegisteredToSmsRecoveryEvent = false;
    var toggleState = null;
    var accountDetails = {};
    var clientCompletedStatus = false;
    var withinValidProfilePeriod = false;
    var congratsDisplayed = false;
    var isPaperBillingSegment = false;
    var segmentDate = null;
    var segmentDateSaved = false;
    var cmsSettingPromise;
    var today = moment().startOf('day');
    var config = [
      {
        completed: true,
        itemKey: 'loginToAccount',
        backgroundImage: 'images/onboarding/onboarding-login.png'
      },
      {
        completed: false,
        itemKey: 'setRecoveryNumber',
        backgroundImage: 'images/onboarding/onboarding-recovery-number.png',
        modal: {
          descriptionTranslationKey: 'onboarding-module.tasks.setRecoveryNumber.modal.description',
          buttons: {
            primary: {
              labelTranslationKey: 'onboarding-module.tasks.setRecoveryNumber.modal.setUpNow',
              altTranslationKey: 'onboarding-module.tasks.setRecoveryNumber.modal.setUpNowAlt',
              cssClass: 'recovery-interceptor',
              callback: function() {
                $('body').on('sms-recovery-phone-changed', function() {
                  completeTask('setRecoveryNumber');
                });
                isRegisteredToSmsRecoveryEvent = true;

                // just to show the back drop when open up modal
                setTimeout(function() {
                  document.body.classList.add('modal-open');
                }, 1000);
              }
            },
            secondary: {
              labelTranslationKey: 'onboarding-module.tasks.setRecoveryNumber.modal.moreInfo',
              altTranslationKey: 'onboarding-module.tasks.setRecoveryNumber.modal.moreInfoAlt',
              callback: function() {
                $window.open('/consumer/content/reset-fido-password?setLanguage=' + uteLocale.language, '_blank');
              }
            }
          }
        }
      },
      {
        completed: false,
        itemKey: 'setAutoPayment',
        backgroundImage: 'images/onboarding/onboarding-auto-pay.png',
        modal: {
          descriptionTranslationKey: 'onboarding-module.tasks.setAutoPayment.modal.description',
          buttons: {
            primary: {
              labelTranslationKey: 'onboarding-module.tasks.setAutoPayment.modal.setUpNow',
              altTranslationKey: 'onboarding-module.tasks.setAutoPayment.modal.setUpNowAlt',
              callback: function() {
                $state.go('myAccount.paymentMethod', { accountNumber: accountDetails.accountNumber });
              }
            }
          }
        }
      },
      {
        completed: false,
        itemKey: 'verifyContactEmail',
        backgroundImage: 'images/onboarding/onboarding-contact-email.png'
      }
    ];

    function isWithinValidProfilePeriod(ignore) {
      if (withinValidProfilePeriod || ignore) {
        return $q.when(true);
      } else {
        return getCmsSettings().then(function(settings) {
          var profileActivationDate = moment(getProfileActivationDate());
          if (!profileActivationDate.isValid()) {
            return $q.reject('API error - problem with ProfileActivationDate');
          } else if (today.isBefore(profileActivationDate.add(settings.validProfilePeriod, 'days'))) {
            withinValidProfilePeriod = true;
            return true;
          } else {
            return $q.reject('not in period');
          }
        });
      }
    }

    function isOpenWirelessAccount() {
      if (
        accountDetails.LOB &&
        accountDetails.LOB.toLowerCase() === 'wl' &&
        accountDetails.accountStatus.toLowerCase() === 'open'
      ) {
        return $q.when(true);
      } else {
        return $q.reject('not an open wireless account');
      }
    }

    function areAllTasksCompleted() {
      return $q.all([isRecoveryNumberCompleted(), isAutoPaymentCompleted()]).then(function(responses) {
        return responses[0] && responses[1];
      });
    }

    function isRecoveryNumberCompleted() {
      var recoveryNumberItem = _.find(config, { itemKey: 'setRecoveryNumber' });

      if (recoveryNumberItem.completed) {
        return $q.when(true);
      } else if (!getGUID()) {
        return $q.reject('no guid');
      } else {
        return recoveryService
          .fetchPhone()
          .then(function(phoneNumber) {
            recoveryNumberItem.completed = true;
            return true;
          })
          .catch(function(data) {
            if (data === 200) {
              return false; // there is no phoneNumber
            } else {
              return $q.reject(data); // API error
            }
          });
      }
    }

    function isAutoPaymentCompleted() {
      var autoPaymentItem = _.find(config, { itemKey: 'setAutoPayment' });
      // for set payment method we should not cache response - because chances are cx change the method again directly from change payment method page
      if (_.has(accountDetails, 'methodOfPaymentDetails.moptype')) {
        autoPaymentItem.completed = accountDetails.methodOfPaymentDetails.moptype.toLowerCase() !== 'r';
        return $q.when(autoPaymentItem.completed);
      } else {
        return $q.reject('API error - autoPay');
      }
    }

    function getGUID() {
      return $window.sessionStorage.getItem('guid');
    }

    function getProfileActivationDate() {
      return $window.localStorage.getItem('profileActivationDate');
    }

    function getXSessionToken() {
      // in some files key name is x_session_token and in some other files it is xSessionToken!
      var xSessionToken = $window.localStorage.getItem('x_session_token');
      if (!xSessionToken) {
        xSessionToken = $window.sessionStorage.getItem('xSessionToken');
      }
      return xSessionToken;
    }

    function getCmsSettings() {
      if (cmsSettingPromise) {
        return cmsSettingPromise;
      }
      cmsSettingPromise = $http
        .get(uteEndpoint('onboarding-margin-day.json?ts=201903201000', 'cms'))
        .then(function(response) {
          return response.data;
        });
      return cmsSettingPromise;
    }

    function checkClientStatus() {
      if (clientCompletedStatus) {
        return $q.reject('completed before - client');
      } else {
        return $q.when('not completed');
      }
    }

    function checkServerStatus() {
      if (!getGUID()) {
        return $q.reject('no guid');
      }
      return $http({
        method: 'GET',
        url: '/pages/web/genesis/api/user/v1/byGUID/' + getGUID() + '/OnlineProfile/onBoardingMessageStatus?brand=FIDO',
        headers: {
          'x-session-token': getXSessionToken()
        }
      }).then(function(response) {
        if (_.get(response, 'data.content.segmentDate')) {
          segmentDate = moment(response.data.content.segmentDate);
        }

        if (!_.has(response, 'data.content.onBoardingStatus')) {
          // if data object does not have status, something is wrong
          return $q.reject('API Error - onBoardingMessageStatus');
        } else if (
          response.data.content.onBoardingStatus &&
          response.data.content.onBoardingStatus.toLowerCase() === 'completed'
        ) {
          return $q.reject('completed before - server');
        } else {
          var contactInfoItem = _.find(config, function(item) {
            return item.itemKey === 'verifyContactEmail' || item.itemKey === 'addContactEmail';
          });
          if (!contactInfoItem) {
            contactInfoItem = {};
          }
          if (
            _.has(response, 'data.content.emailVerified') &&
            response.data.content.emailVerified &&
            response.data.content.emailVerified.toLowerCase() === 'completed'
          ) {
            // if onBoardingStatus is not completed AND emailVerified is completed, set the emailVerified task to true
            contactInfoItem.completed = true;
          } else {
            contactInfoItem.itemKey = accountDetails.contactEmail ? 'verifyContactEmail' : 'addContactEmail';
            contactInfoItem.emailAddress = accountDetails.contactEmail;
          }
          return $q.when('not completed');
        }
      });
    }

    function setServerStatus(emailVerified, setSegmentDate) {
      var isLastTask = countCompletedTasks() === config.length - 1;
      var request = {
        brand: 'FIDO'
      };
      if (setSegmentDate) {
        request.accountNumber = commonService.wirelessAccountNumber;
      } else {
        if (emailVerified && isLastTask) {
          request.emailVerified = 'Completed';
          request.status = 'Completed';
        } else if (emailVerified && !isLastTask) {
          request.emailVerified = 'Completed';
        } else {
          request.status = 'Completed';
        }
      }

      return $http({
        method: 'POST',
        url: '/pages/web/genesis/api/user/v1/byGUID/' + getGUID() + '/OnlineProfile/onBoardingMessageStatus',
        headers: {
          'x-session-token': getXSessionToken()
        },
        data: request
      }).then(function(response) {
        if (_.has(response, 'data.status.code') && response.data.status.code === '200.001') {
          if (request.status === 'Completed') {
            clientCompletedStatus = true; // set client completed status to true only when server is updated successfully
            dataLayerService.track({}, false, [0, 1, 4], { mappingKey: 'onboarding.onboardingCompleted' });
          }
          response.isSuccess = true;
          return response;
        } else {
          response.isSuccess = false;
          return response;
        }
      });
    }

    function updateContactEmail(email) {
      return $http({
        method: 'POST',
        url: uteEndpoint('v2/updateContactInformation'),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: $.param({
          email: email,
          accountNumber: accountDetails.accountNumber,
          mobile: '',
          business: '',
          home: '',
          businessExtn: '',
          language: ''
        })
      }).then(function(response) {
        if (response.data && !response.data.error) {
          if (countCompletedTasks() === config.length - 1) {
            // if Change Contact or Add Contact is last task, on success of 'updateContactInformation' track 100% onboard completion
            dataLayerService.track({}, false, [0, 1, 4], { mappingKey: 'onboarding.onboardingCompleted' });
          }
          response.isSuccess = true;
          return response;
        } else {
          response.isSuccess = false;
          return response;
        }
      });
    }

    function triggerAlertRole() {
      // to make screen-reader (voiceOver) announce the amount of progress, we need to set role="alert" on progressbar element, after completing each task.
      $('.onboarding-progress-bar').removeAttr('role');
      setTimeout(function() {
        $('.onboarding-progress-bar').attr('role', 'alert');
      }, 2000);
    }

    function completeTask(key) {
      var item = _.find(config, { itemKey: key });

      if (item) {
        item.completed = true;
        triggerAlertRole();
      }

      //when all task are completed, need to save the state in the server.
      if (countCompletedTasks() === config.length) {
        setServerStatus(false);
      }
    }

    function handleAllTasksCompletedRes(allCompleted) {
      if (!segmentDateSaved && isPaperBillingSegment && !segmentDate) {
        setServerStatus(false, true).then(function(res) {
          if (res.isSuccess) {
            segmentDateSaved = true;
          }
        });
      }
      if (allCompleted && congratsDisplayed) {
        setServerStatus(false);
      }
      return !(allCompleted && congratsDisplayed);
    }

    function handleShowOnboardingError(res) {
      if (typeof res === 'string') {
        console.log('hide onboarding, reason: ', res);
      } else {
        var data = res.data;
        var payload = dataLayerService.getConfigByMappingKey({
          mappingKey: 'advance.mappingKey.error.onboarding'
        });
        var api = res.config.url;
        var errorType = $window.ute.datalayer.common.service.ErrorType;
        var errorCategory = $window.ute.datalayer.common.service.ErrorCategory;
        var dataLayerPredefinedSection = $window.ute.datalayer.common.service.DataLayerPredefinedSection;
        var globalObjects = [
          dataLayerPredefinedSection.ACCOUNT,
          dataLayerPredefinedSection.PAGE,
          dataLayerPredefinedSection.SITE,
          dataLayerPredefinedSection.GLOBAL
        ];

        if (_.has(data, 'status.code')) {
          dataLayerService.trackError(
            payload,
            errorType.HTTP,
            data.status.code,
            data.status.codeName,
            errorCategory.SELF_SERVE,
            '',
            api,
            false,
            globalObjects
          );
        } else {
          if (res.status === 404 && res.statusText === '') {
            res.statusText = 'API Not found';
          }
          dataLayerService.trackError(
            payload,
            errorType.HTTP,
            res.status,
            res.statusText,
            errorCategory.SELF_SERVE,
            '',
            api,
            false,
            globalObjects
          );
        }
      }

      return false;
    }

    function showOnboardingModule() {
      return checkClientStatus()
        .then(checkServerStatus)
        .then(isWithinValidProfilePeriod)
        .then(isOpenWirelessAccount)
        .then(areAllTasksCompleted)
        .then(handleAllTasksCompletedRes)
        .catch(handleShowOnboardingError);
    }

    function getConfig() {
      return config;
    }

    function setAccountDetails(details) {
      accountDetails = details;
    }

    function countCompletedTasks() {
      return (
        _.countBy(config, function(item) {
          return item.completed;
        }).true || 0
      );
    }

    function setToggleState(state) {
      toggleState = state;
    }

    function getToggleState() {
      return toggleState;
    }

    function checkRegisteredToSmsRecoveryEvent() {
      return isRegisteredToSmsRecoveryEvent;
    }

    function setCongratsDisplayed() {
      congratsDisplayed = true;
    }

    return {
      showOnboardingModule: showOnboardingModule,
      setAccountDetails: setAccountDetails,
      setToggleState: setToggleState,
      getToggleState: getToggleState,
      countCompletedTasks: countCompletedTasks,
      checkRegisteredToSmsRecoveryEvent: checkRegisteredToSmsRecoveryEvent,
      setCongratsDisplayed: setCongratsDisplayed,
      getConfig: getConfig,
      setServerStatus: setServerStatus,
      updateContactEmail: updateContactEmail,
      triggerAlertRole: triggerAlertRole
    };
  }
})();
